import moment from 'moment-timezone';

export interface KeyValueRow {
  key: string;
  value: string;
}

/** "Only on certain days / times": the day chips and a local hh:mm window (54, 62). */
export interface DayTimeWindow {
  on: boolean;
  days: string[];
  from: string;
  to: string;
}

export const newWindow = (): DayTimeWindow => ({ on: false, days: [], from: '', to: '' });

export const newRow = (): KeyValueRow => ({ key: '', value: '' });

export const filledRows = (rows: KeyValueRow[]) =>
  rows.filter(row => row.key.trim() !== '' && row.value.trim() !== '');

const TIME = /^([01]\d|2[0-3]):[0-5]\d$/;

export const isTime = (value: string) => TIME.test(value);

/**
 * What a checked window still lacks: a day, two hh:mm times, and the end after the start. An
 * unchecked window never blocks.
 */
export const windowErrors = (
  window: DayTimeWindow,
  messages: { days: string; time: string; order: string }
): string[] => {
  if (!window.on) {
    return [];
  }
  const errors: string[] = [];
  if (window.days.length === 0) {
    errors.push(messages.days);
  }
  if (!isTime(window.from) || !isTime(window.to)) {
    errors.push(messages.time);
  } else if (window.to <= window.from) {
    errors.push(messages.order);
  }
  return errors;
};

/** The tenant zone's offset as the frames print it, "+08:00". */
export const zoneOffset = (timezone: string, at: string | null = null) =>
  (at === null ? moment() : moment(at)).tz(timezone).format('Z');

/** "28 Oct 2026 09:00:00", the review's date format (55). */
export const reviewDateTime = (value: string, timezone: string) =>
  moment(value).tz(timezone).format('D MMM YYYY HH:mm:ss');

/** "30 Oct 2026 12:30", the reward review's shorter format (66). */
export const reviewDateMinute = (value: string, timezone: string) =>
  moment(value).tz(timezone).format('D MMM YYYY HH:mm');

export const thousands = (value: string | number) => Number(value).toLocaleString('en-US');

// The module's own fallback when the tenant sets no timezone (`pages/campaign/create.tsx`).
export const DEFAULT_TIMEZONE = 'Asia/Kuala_Lumpur';
